/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Mfa_Email_Code_LabelInputs */

const de_auth_mfa_email_code_label = /** @type {(inputs: Auth_Mfa_Email_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigungscode`)
};

/** @type {(inputs: Auth_Mfa_Email_Code_LabelInputs) => LocalizedString} */
const en_auth_mfa_email_code_label = de_auth_mfa_email_code_label;

/**

* @param {Auth_Mfa_Email_Code_LabelInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_mfa_email_code_label = /** @type {((inputs?: Auth_Mfa_Email_Code_LabelInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Mfa_Email_Code_LabelInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_mfa_email_code_label(inputs)
	return en_auth_mfa_email_code_label(inputs)
});